import { LANG_ES, LANG_EN, ES_TEXT, EN_TEXT } from "@/constants/Language";

const getLanguageText = (langCode) => {
  switch (langCode) {
    case LANG_ES:
      return ES_TEXT;
    case LANG_EN:
      return EN_TEXT;
    default:
      break;
  }
};

export default getLanguageText;
